export default __webpack_public_path__ + "static/media/wishlist.d1dc4977.png";